import { lazy } from 'react';
import { SidebarLayout } from '@trukt/ui/SidebarLayout';
import { RouteObject } from 'react-router-dom';

import { PATH_NAMES, ORDERS_PREFIX } from '../../shared';
import { SidebarContainer } from '../../components';

const OrderView = lazy(() => import('../../OrderView'));
const OrderDetailView = lazy(() => import('../../OrderView/components/OrderDetailView'));
const OrderAttachmentsView = lazy(() => import('../../OrderView/components/OrderAttachmentsView'));

export const ORDER_ROUTES: RouteObject[] = [
  {
    path: PATH_NAMES.ROOT,
    element: <SidebarLayout sidebar={<SidebarContainer />} />,
    children: [
      {
        path: `${ORDERS_PREFIX}/:orderGuid`,
        element: <OrderView />,
        children: [
          {
            path: `/${ORDERS_PREFIX}/:orderGuid`,
            element: <OrderDetailView />,
          },
          {
            path: `/${ORDERS_PREFIX}/:orderGuid/attachments`,
            element: <OrderAttachmentsView />,
          },
        ],
      },
    ],
  },
];
